import React, { Component } from 'react';
import axios from 'axios';
import {API_URL, DOMAIN_MULTIMEDIA} from '../../constants';
import cookie from 'react-cookies';
import { toast } from 'react-toastify';
import {hideModalPageClass, toBase64, updateValueInJson} from '../../functions';
import Moment from 'moment';
import $ from 'jquery';
import ImageUploader from 'react-images-upload';

export default class ModalMultimedia extends Component {

    constructor(props) {

        super(props);

        this.state = {
            resource: {
                sArchivoID:"03977376-4DEF-45BA-B810-934A55A6DA16",
                sArchivoExtension:"png",
                sArchivoTipo:"imagenes",
                sArchivoData:"",
                sArchivoRuta:"",
                sCategoriaArchivo:"",
                bEliminado:false,
                bUsado:false,
                nUsuarioCodigo:0,
                nArchivoCodigo:0,
                isEdition:false,
                nArchivoTamano:0,
                dFechaUpload:"",
                dFechaCreacion:"",
                dFechaModificacion:"",
                sTipoRecurso: "",
                bActivo:true,
                nUsuarioCreacion:0,
                nUsuarioModificacion:0,
                sArchivoNombre:""
            },
            archivos:[],
            directorios:[],
            paginaDirectorios:0,
            response: [],
            error: [],
            security: cookie.load('user'),
            roles: [],
            filters:{
                archivo:'',
                categoria:'',
                directorio:'',
            },
            pagina: 1,
            added: false,
            addDirectorio:false
          }

        this.handleInputChangeFilter = this.handleInputChangeFilter.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    clearFile=()=>{
        let resource = this.state.resource;


        resource.dFechaCreacion = "";
        resource.dFechaModificacion = "";
        resource.dFechaUpload = "";
        resource.nArchivoTamano = 0;
        resource.nUsuarioCreacion = 0;
        resource.nUsuarioModificacion = 0;
        resource.sArchivoNombre = "";
        resource.sCategoriaArchivo = "";

        resource.sArchivoData = "";
        resource.sArchivoRuta = "";
        resource.sArchivoExtension = "";
        resource.nUsuarioCodigo = 0;
        resource.nArchivoCodigo=0;
        resource.isEdition = false;
        this.setState({resource:resource});
    }

    onDrop=(picture)=>{

        let resource = this.state.resource;
        resource.sArchivoData = "";
        resource.sArchivoExtension = "";

        if(!this.state.resource.isEdition){
            resource.sArchivoRuta = "";
        }
        if (picture.length>0)
        {
            var file = picture[picture.length-1];

            let type = file.type;

            let arrayFile = type !== '' ? type.split('/') : [];

            if(arrayFile.length > 0){
                resource.sArchivoExtension = arrayFile[1];
                resource.sArchivoNombre = file.name;
                resource.nArchivoTamano = file.size;
            }

            toBase64(file).catch(e => e).then(
                (data)=>
                {

                    resource = updateValueInJson(resource,'sArchivoData', data);

                    this.setState({resource:  resource});

                }
            );
        } else
        {
            this.setState({resource:  updateValueInJson(resource, "sArchivoData", null)});
        }
    }

    cambiarImagen = () => {
        $(".chooseFileButton").trigger("click");
    }

    editarArchivo = (data, isDelete = false) => {

        $('.listaArchivos').hide();

        if(isDelete){
            data.bEliminado = isDelete;

            this.setState({resource:data});

            setTimeout(() => {
                this.actualizarArchivo();
            }, 100);

            return;
        }

        let resource = this.state.resource;
        resource.sArchivoRuta = data.sArchivoRuta;
        resource.sArchivoExtension = data.sArchivoExtension;
        resource.nUsuarioCodigo = data.nUsuarioCodigo;
        resource.nArchivoCodigo=data.nArchivoCodigo;

        resource.isEdition = true;

        this.setState({resource:resource});
    }

    cancelarEdicion = () => {
        this.clearFile();
        $('.listaArchivos').show();
    }

    paginationTableDirectorios()
    {
        // console.log("pagination TableDirectorios - state.directorios: ", this.state.directorios)
        var entity = this.state.directorios.length > 0 ? this.state.directorios[0] : null;
        const options = [];

        if (entity !== null){
            entity.totalPages = 2;
            if(entity.totalPages <= 1){
                return null;
            }

            /*options.push(<a className="btnPrevPaginadorExportador" id={0} key={0} onClick={(e) => this.executePaginationDirectorio(0, e)}></a>);*/

            for(let index=1; index < entity.totalPages+1; index++)
                options.push(<a id={index} key={index} onClick={(e) => this.executePaginationDirectorio(index, e)}> {index} </a>);

            if((entity.totalRows % entity.totalPages) > 0){
                let newPage = entity.totalPages + 1;
                options.push(<a id={newPage} key={newPage} onClick={(e) => this.executePaginationDirectorio(newPage, e)}> {newPage} </a>);
            }

            /*options.push(<a className="btnNextPaginadorExportador" id="lastPage" key={entity.totalPages+1} onClick={(e) => this.executePaginationDirectorio(entity.totalPages+1, e)}></a>);*/

        return (
            <div className="divPaginadorExportador" key={"pagination_directory"} id="paginationDirectorios" style={{position:"relative"}}>
                {options}
            </div>
        );
        }
    }

    executePaginationDirectorio(page, e){

        if(e != undefined){
            e.preventDefault();
        }

        var entity = this.state.directorios.length>0?this.state.directorios[0]:null;
        for(let index=0; index < entity.totalPages+2; index++)
        {
            if($("#"+index).is("*"))
			{
				document.getElementById(index).classList.remove("active");
			}
        }

        if($("#"+page).is("*"))
		{
			document.getElementById(page).classList.add("active");
        }

        let directorio = this.state.filters.directorio;

        if(directorio == ""){
            this.cargarCarpetas(page);
        }else{
            this.cargarCarpetas(page, directorio);
        }



    }

    executePagination(page, e){

        if(e != undefined){
            e.preventDefault();
        }

        var entity = this.state.archivos.length>0?this.state.archivos[0]:null;

        for(let index=0; index < entity.totalPages+2; index++)
        {
            if($("#"+index).is("*"))
			{
				document.getElementById(index).classList.remove("active");
			}
        }

        if($("#"+page).is("*")){
			document.getElementById(page).classList.add("active");
        }

       let categoria = this.state.filters.categoria;
        if(categoria != ""){
            this.cargarArchivos(page, categoria);
        }else{
            this.cargarArchivos(page);
        }


    }



    paginationTable()
    {
        var entity = this.state.archivos.length > 0 ? this.state.archivos[0] : null;

        const options = [];

        if (entity !== null){

            if(entity.totalPages <= 1){
                return null;
            }

            options.push(<a className="btnPrevPaginadorExportador" id={0} key={0} onClick={(e) => this.executePagination(0, e)}></a>);

            for(let index=1; index < entity.totalPages+1; index++)
                options.push(<a id={index} key={index} onClick={(e) => this.executePagination(index, e)}> {index} </a>);

            if((entity.totalRows % entity.totalPages) > 0){
                let newPage = entity.totalPages + 1;
                options.push(<a id={newPage} key={newPage} onClick={(e) => this.executePagination(newPage, e)}> {newPage} </a>);
            }

            options.push(<a className="btnNextPaginadorExportador" id="lastPage" key={entity.totalPages+1} onClick={(e) => this.executePagination(entity.totalPages+1, e)}></a>);

        return (
            <div className="divPaginadorExportador" key={"pagination"} id="pagination">
                {options}
            </div>
        );
        }
    }

    handleInputChangeFilter(event) {

        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        let copyResource = this.state.filters;
        copyResource[target.name] = value;

        this.setState({
            filters: copyResource
        });
    }

    handleInputChange(event) {

        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        let copyResource = this.state.resource;
        copyResource[target.name] = value;

        this.setState({
            resource: copyResource
        });
    }

    returnFilePath = (urlFile = "") => 
	{
        this.props.callback(urlFile);
        hideModalPageClass("divGestorArchivos");
		
		if($(".cke_dialog_image_url input").is("*"))
		{
			$(".cke_dialog_image_url input").val(urlFile);
		}
    }

    _handleKeyDownFile = (e) => {
        if (e.key === 'Enter') {
            this.searchArchivos(e);
        }
    }

    _handleKeyDownDir = (e) => {
        if (e.key === 'Enter') {
            this.searchDirectorios(e);
        }
    }

    multimediaPath(nameFile = ""){
        return DOMAIN_MULTIMEDIA + nameFile;
    }

    searchDirectorios = (event) => {


        var textoFilter = this.state.filters.directorio;

        if(textoFilter == ""){
            this.cargarCarpetas(1);
            return;
        }

        this.cargarCarpetas(1,textoFilter);
    }

    searchArchivos = (event) => {


        var filter = this.state.filters;

        if(filter.archivo == ""){
            filter.archivo = "ALL"
        }

        if(filter.categoria == ""){
            filter.categoria = "ALL"
        }

        this.cargarArchivos(1, filter.categoria, filter.archivo);
    }

    seleccionarDirectorio = (categoria = "") => {
        if(categoria !== ""){
            this.cargarArchivos(1, categoria);
        }
    }

    componentDidMount(){
        this.cargarCarpetas();
    }

    cargarCarpetas = (page = 0, categoria = "ALL") => {

        const url = `${API_URL}MultimediaUX/ListarDirectorios/${categoria}/${page}`;
        axios.get(url).then(response => response.data)
        .then((data) => {

            this.setState({ directorios: data.result, paginaDirectorios: page });
        })
        .catch(error => {
        });
    }

    regresarCarpetas = () => {

        let filter = this.state.filters;
        filter.categoria = "";

        this.setState({filters:filter});
    }

    agregarDirectorio = () => {
        this.setState({addDirectorio:true});
    }

    cancelarNuevoDirectorio = () => {
        this.setState({addDirectorio:false});
    }

    cargarArchivos = (page = 1, categoria = "ALL", archivo = "ALL") => {

        let filter = this.state.filters;
        filter.categoria = categoria;

        const url = `${API_URL}MultimediaUX/ListarArchivos/${categoria}/${page}/${archivo}`;

        axios.get(url).then(response => response.data)
        .then((data) => {

            let resource = this.state.resource;
            resource.sCategoriaArchivo = categoria;

            this.setState({ archivos: data.result, response: data, pagina: page, filters:filter, resource:resource });
        })
        .catch(error => {
        });
    }

    subirNuevoArchivo = () => {

        setTimeout(() => {
            $('.formNuevoArchivo').show();

            $('.nuevoArchivo').hide();
            $('.listaArchivos').hide();
            $('.volverMain').hide();
        }, 100);


    }

    salirGestorMultimedia = () => {
        this.cancelarNuevoArchivo();
        this.cancelarEdicion();
        this.cancelarNuevoDirectorio();
        hideModalPageClass("divGestorArchivos");

    }

    cancelarNuevoArchivo = () => {
        $('.formNuevoArchivo').hide();


        $('.nuevoArchivo').show();
        $('.listaArchivos').show();
        $('.volverMain').show();
    }

    actualizarArchivo = () => {
        let newState = this.state;
        newState.hasError = false;

        if (newState.resource.sArchivoData == '' && !newState.resource.bEliminado) {
            newState.hasError = true;

            this.setState(newState);
            return;
        }

        const url = `${API_URL}MultimediaUX/`;
        var dataForm = this.state.resource;
        dataForm = updateValueInJson(dataForm,'nUsuarioModificacion', this.state.security.nUsuCodigo);

        const formData = JSON.stringify(dataForm);

        axios.put(
        url,
        JSON.stringify(formData),
        {
            headers: {
                'Content-Type': 'application/json; charset=UTF-8' ,
                'Accept': 'application/json'
            }
        }
        ).then(
            (data)=> {
                if (data.data.isSucess)
                {
                    this.setState({added:true});


                    this.executePagination(this.state.pagina);
                    this.cancelarEdicion();
                    setTimeout(() => {
                        this.setState({added:false});
                    }, 5000);

                } else
                {
                    this.setState({hasErrorProceso:true});

                    setTimeout(() => {
                        this.setState({hasErrorProceso:false});
                    }, 3000);
                }
            }
        ).catch((error)=> {
            toast.error('Error no controlado.');
            this.setState({loading:false});
        });
    }

    guardarArchivo = (tipo = "") => {
        let newState = this.state;
        newState.hasError = false;

        if (newState.resource.sArchivoData == '' && tipo !== "directorio") {
            newState.hasError = true;

            this.setState(newState);
            return;
        }

        const url = `${API_URL}MultimediaUX/`;
            var dataForm = this.state.resource;

            if (tipo === "directorio")
            {
                dataForm = updateValueInJson(dataForm,'sArchivoNombre', dataForm.sCategoriaArchivo);
            }

            dataForm = updateValueInJson(dataForm,'nUsuarioCreacion', this.state.security.nUsuCodigo);
            dataForm = updateValueInJson(dataForm,'nUsuarioCodigo', this.state.security.nUsuCodigo);
            dataForm = updateValueInJson(dataForm,'dFechaUpload', Moment());
            dataForm = updateValueInJson(dataForm,'dFechaCreacion', Moment());
            dataForm = updateValueInJson(dataForm,'dFechaModificacion', Moment());

            const formData = JSON.stringify(dataForm);

        axios.post(
        url,
        JSON.stringify(formData),
        {
            headers: {
                'Content-Type': 'application/json; charset=UTF-8' ,
                'Accept': 'application/json'
            }
        }
        ).then(
            (data)=> {
                if (data.data.isSucess)
                {
                    this.setState({added:true});

                    this.clearFile();

                    if(this.state.addDirectorio){
                        this.cargarCarpetas();
                        this.cancelarNuevoDirectorio();
                    }else{
                        this.executePagination(1);
                    }



                    setTimeout(() => {
                        this.setState({added:false});
                    }, 5000);

                } else
                {
                    this.setState({hasErrorProceso:true});

                    setTimeout(() => {
                        this.setState({hasErrorProceso:false});
                    }, 3000);
                }
            }
        ).catch((error)=> {
            toast.error('Error no controlado.');
            this.setState({loading:false});
        });

    }

    render() {

        Moment.updateLocale('en', {
            months : [
                "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio",
                "Agosto", "Setiembre", "Octubre", "Noviembre", "Diciembre"
            ]
        });

        Moment.updateLocale('en', {
            weekdays : [
                "Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"
            ]
        });

        return (
                <div className={"divGestorArchivos " + this.props.class} style={{display:"none"}}>
                    <div className="divLayerPopup_GestorArchivos">
                        <div className="divPopup_GestorArchivos">
                        <div className="divClosePopup_GestorArchivos" onClick={() => this.salirGestorMultimedia()}/>
                        <h2>Gestor de Archivos </h2>
                        <div className="divWrapperGestorArchivos">


                            {
                                this.state.filters.categoria == "" ?
                                    <React.Fragment>
                                        {

                                        this.state.addDirectorio ?
                                            <React.Fragment>
                                                <div className="containerFormCreation divModuloPopup_Panel">
                                                    <p>Nueva carpeta</p>

                                                    <div className="txtFile x-2">
                                                        <input type="text" placeholder="Nombre" name='sCategoriaArchivo' value={this.state.resource.sCategoriaArchivo}
                                                        onChange={this.handleInputChange}/>
                                                    </div>
                                                </div>
                                                <div className="divBtnGestorArchivos">
                                                    <a href className="btnActivo formNuevoArchivo noneEvent" onClick={() => this.guardarArchivo("directorio")}>GUARDAR </a>
                                                    <a href="#" className="noneEvent formNuevoArchivo" onClick={() => this.cancelarNuevoDirectorio()}>VOLVER</a>
                                                </div>

                                            </React.Fragment>
                                        :
                                            <React.Fragment>
												<div className="divSearchGestorArchivos divSearchDirHidden">
													<input type="text" placeholder="Buscar carpeta" name="directorio" onKeyDown={this._handleKeyDownDir} onChange={this.handleInputChangeFilter}/>
													<input type="submit" defaultValue="Buscar" onClick={(event) => this.searchDirectorios(event)}/>
												</div>
                                                <div className="divListadoGestorArchivos">
                                                    <div className="divListadoGestorPg">
														{this.paginationTableDirectorios()}
                                                    </div>
													<div className="divLimpiarPaginador"></div>

                                                    <div className="divScroll">

                                                        <ul className="listItemDirectorios">
                                                            {
                                                                this.state.directorios.length > 0 ?
                                                                this.state.directorios.map((directorio, index) => (
                                                                    <li className={"___"+directorio.sCategoriaArchivo} key={"dir_" + index} onClick={() => this.seleccionarDirectorio(directorio.sCategoriaArchivo)}>
                                                                        <span>{directorio.sCategoriaArchivo}</span>
                                                                    </li>
                                                                ))
                                                                : null
                                                            }
                                                        </ul>
                                                        <div className="clear" />
                                                    </div>
                                                </div>

                                                <div className="divBtnGestorArchivos">
                                                    <a href="#" style={{display:"none"}} className="hiddenbtnDir btnActivo nuevoArchivo noneEvent" onClick={() => this.agregarDirectorio()}>NUEVA CARPETA</a>
                                                    <a href="#" className="noneEvent volverMain" onClick={() => this.salirGestorMultimedia()}>VOLVER</a>
                                                </div>
                                            </React.Fragment>
                                        }

                                    </React.Fragment>
                                :

                                <React.Fragment>

                                    <div className="divSearchGestorArchivos">
                                        <input type="text" placeholder="Buscar archivos" name="archivo" onKeyDown={this._handleKeyDownFile} onChange={this.handleInputChangeFilter}/>
                                        <input type="submit" defaultValue="Buscar" onClick={(event) => this.searchArchivos(event)}/>
                                    </div>

                                    <div class="divExportadores listaArchivos">
                                    <h3> / {this.state.filters.categoria}</h3>
                                        {this.paginationTable()}
                                        <div class="clear"></div>
                                        <div class="divTablaExportadores scrollgeneral">
                                            <table border="1" cellspacing="0" className="seleccionarArchivosEImagenes">
                                                <tr>
                                                    <th>Fichero</th>
                                                    <th></th>
                                                    <th></th>
                                                    <th>Fecha</th>
                                                </tr>
                                                {
                                                    this.state.archivos.length > 0 ?
                                                    this.state.archivos.map((archivo, index) => (
                                                        <tr key={"archivo_" + archivo.nArchivoCodigo}>
                                                            <td onClick={() => this.returnFilePath(this.multimediaPath(archivo.sArchivoRuta))}>
																<div class="archivoTabla">

																		{
																			(archivo.sArchivoTipo == 'pdf' || archivo.sArchivoTipo == 'xls' || archivo.sArchivoTipo == 'xlsx' || archivo.sArchivoTipo == 'doc' || archivo.sArchivoTipo == 'docx' || archivo.sArchivoTipo == 'ppt' || archivo.sArchivoTipo == 'pptx' || archivo.sArchivoTipo == 'csv' || archivo.sArchivoTipo == 'txt')
																			?<a href="" className="noneEvent aOnlyFile"><img src={"/static/images/icoReportes.png"} alt={archivo.sArchivoNombre} height="35" /></a>
																			:<a href="" className="noneEvent"><img src={this.multimediaPath(archivo.sArchivoRuta)} alt={archivo.sArchivoNombre} width="45" height="45" /></a>
																		}
																</div>
															</td>
                                                            <td onClick={() => this.returnFilePath(this.multimediaPath(archivo.sArchivoRuta))}><strong>{archivo.sArchivoNombre}</strong></td>
                                                            <td>
                                                                <a href="#" className="noneEvent" style={{display:"none"}} onClick={() => this.editarArchivo(archivo)}>Editar Archivo</a>
																<a href="#" className="noneEvent" onClick={() => this.editarArchivo(archivo, true)}>
																	<img src="/static/images/icoDeleteTabla.jpg" alt="Eliminar archivo" title="Eliminar archivo" />
																</a>
                                                            </td>
                                                            <td>{Moment(archivo.dFechaUpload).format('DD/MM/YYYY')}</td>
                                                        </tr>
                                                    ))
                                                    : null
                                                }
                                            </table>
                                        </div>
                                    </div>



                                    {
                                        this.state.resource.isEdition ?
                                            <div className="divAddExportadores">
                                                <h3>Exportadores del Perú</h3>
                                                <div className="clear" />
                                                <div className="divReemplazarImagen">
                                                    {
                                                        this.state.resource.sArchivoData !== "" ?
                                                        <img style={{width:"100%"}} src={this.state.resource.sArchivoData}/>
                                                        : <img style={{width:"100%"}} src={this.multimediaPath(this.state.resource.sArchivoRuta)}/>
                                                    }

                                                    <a href="#" className="noneEvent" onClick={() => this.cambiarImagen()}>Reemplazar Imagen</a>
                                                    <div style={{display:"none"}}>
                                                        <ImageUploader label="Formatos aceptados: JPEG - JPG - GIF - PNG - WEBM"  id="Uploader" singleImage={true}  withPreview={false} withIcon={true} buttonText='Seleccionar ficheros' onChange={this.onDrop} imgExtension={['.jpeg','.jpg', '.gif', '.png', '.gif']} maxFileSize={5242880}/>
                                                    </div>
                                                </div>
                                                <div className="divDescriptionExportador">
                                                    <input type="text" placeholder="Exportación interna" />
                                                    <textarea defaultValue={"Descripción"} />
                                                    <p>
                                                    Autor: Admin <br />
                                                    Fecha: 28/01/2020
                                                    </p>
                                                    <a href="#" className="noneEvent" onClick={() => this.actualizarArchivo()}>ACTUALIZAR</a>
                                                    <a href="#" className="noneEvent" onClick={() => this.cancelarEdicion()}>CANCELAR</a>
                                                </div>
                                                <div className="clear" />
                                            </div>
                                        :

                                        <div class="divUploadMultimedia formNuevoArchivo" style={{display:"none"}}>

                                            <div className="relative">
                                                {
                                                    this.state.added ?
                                                    <div className="textAlertaOK">
                                                        <div>Se registró la imagen satisfactoriamente</div>
                                                    </div> : null
                                                }

                                            </div>

                                            <h3>Subir nuevo multimedia</h3>

                                            {
                                                this.state.resource.sArchivoData !== "" ?
                                                <div style={{width:"150px"}}>
                                                    <img style={{width:"100%"}} src={this.state.resource.sArchivoData}/>
                                                    <a href="#" className="noneEvent" onClick={() => this.clearFile()}>Elegir otro archivo</a>
                                                </div>
                                                :
                                                <div class="divWraperUploadMultimedia">
                                                    <div>
                                                        <ImageUploader label="Formatos aceptados: JPEG - JPG - GIF - PNG"  id="Uploader" singleImage={true}  withPreview={false} withIcon={true} buttonText='Seleccionar ficheros' onChange={this.onDrop} imgExtension={['.jpeg','.jpg', '.gif', '.png', '.gif']} maxFileSize={5242880}/>
                                                    </div>
                                                </div>
                                            }


                                            <div class="clear"></div>
                                        </div>
                                    }

                                <div className="divBtnGestorArchivos">
                                    <a href className="btnActivo nuevoArchivo noneEvent" onClick={() => this.subirNuevoArchivo()}>SUBIR NUEVO </a>
                                    <a href className="btnActivo formNuevoArchivo noneEvent" style={{display:"none"}} onClick={() => this.guardarArchivo()}>GUARDAR </a>
                                    <a href="#" className="noneEvent formNuevoArchivo" style={{display:"none"}} onClick={() => this.cancelarNuevoArchivo()}>VOLVER</a>
                                    <a href="#" className="noneEvent volverMain" onClick={() => this.regresarCarpetas()}>VOLVER</a>
                                </div>

                                </React.Fragment>

                            }


                        </div>
                        </div>
                    </div>
                    </div>

        )
    }
}
